'use strict';

var S1 = require('./select1');

var _bestOf = S1.bestOfN(2);
var _bestOf2 = S1.bestOfN(3);

module.exports = {
  random: function random(c, arr) {
    return [S1.random(c, arr), S1.random(c, arr)];
  },
  bestOf2: function bestOf2(c, arr) {
    return [_bestOf(c, arr), _bestOf(c, arr)];
  },
  bestOf3: function bestOf3(c, arr) {
    return [_bestOf2(c, arr), _bestOf2(c, arr)];
  },
  bestOfN: function bestOfN(n) {
    var bestOf = S1.bestOfN(n);
    return function (c, arr) {
      return [bestOf(c, arr), bestOf(c, arr)];
    };
  },
  fittestAndRandom: function fittestAndRandom(c, arr) {
    return [arr[0], S1.random(c, arr)];
  }
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/evolutionary/select2.js
 ** module id = 229
 ** module chunks = 0
 **/